import * as angular from "angular";
import { ApiUserService } from "../../services/user.service";
import { ToastUtils } from "../../helper/toast.helper";

let LeaderAdminCreateCampaignModalComponent = {
    selector: "vcLeaderAdminCreateCampaignModal",
    templateUrl:
        "/angular/components/organisation/create-organisation-campaign.component.html",
    bindings: {
        modalinstance: "=",
        activeorganisation: "=",
    },
    controller: class LeaderAdminCreateCampaignModalController {
        // * bindings for typescript compiler *
        public modalinstance: any;
        public activeorganisation: any;
        // ************************************

        private loading: boolean = false;
        private apiUserService: ApiUserService;

        private toast: ToastUtils;
        private __env: any;

        constructor(
            ApiUserService: ApiUserService,
            ToastUtils: ToastUtils,
            __env: any
        ) {
            this.toast = ToastUtils;
            this.__env = __env;

            this.apiUserService = ApiUserService;
        }

        saveCampaign(): void {
            this.loading = false;
            if (this.loading == false) {
                this.loading = true;
                this.apiUserService
                    .sandboxRegister(this.activeorganisation)
                    .then((response) => {
                        let json = response["data"];
                        if (json.success) {
                            this.toast.success("Created Campaign");
                            this.modalinstance.close(json);
                        } else {
                            this.toast.error();
                            this.dismissModal();
                        }
                        this.loading = false;
                    });
            }
        }

        dismissModal(): void {
            this.modalinstance.dismiss();
        }
    },
};

angular
    .module("organisation", [])
    .component(
        LeaderAdminCreateCampaignModalComponent.selector,
        LeaderAdminCreateCampaignModalComponent
    );
